/**
 * created by lei lei
 * 人脸识别
 *
 */
import React, {Component} from 'react';
import {Scrollbars} from "react-custom-scrollbars";
import {Empty, Pagination, Tabs, Table, Input, Button, Card, message, Progress} from "antd";
import *as Actions from "../../actions/faceRecognition"
import SpacerBlock from '../components/spacerBlock/SpacerBlock'
import {connect} from "react-redux";

const {TabPane} = Tabs;

class FaceRecognition extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Actions = Actions
        this.state = {
            labeled: '0',
            page: 1,
            page_size: 10,
            dataSource: [],
            total: 0,
            initialized: false,//按钮是否可点击，默认false 可以点击。
            data: 0,
            btnStatus: false,

        }
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps.config.getValueByKey("face_recognition.all_pictures.scan.enable"));
        let btnStatus = nextProps.config.getValueByKey("face_recognition.all_pictures.scan.enable", '0');
        //console.log(typeof btnStatus);
        if (btnStatus === '0') {
            this.setState({btnStatus: false})
        } else {
            this.setState({btnStatus: true})
        }
    }

    componentDidMount() {

        this.getNoPoint();
        this.initFaceMeta();//获取人脸初始化
        if (this.state.initialized) {//点击过自动获取进度条
            this.initProgress()//获取进度条数据
        }

    }

    getNoPoint() {
        this.Actions.getFaceList(parseInt(this.state.labeled), this.state.page, this.state.page_size, (data) => {
            let Data = data.data;
            if (Data && Data.list.length) {
                Data.list.forEach((item, i) => {
                    item.key = i;
                    item.checked = false;
                });
                this.state.dataSource = Data.list;
                this.state.total = Data.total;
            } else {
                this.state.dataSource = [];
                this.state.total = 0;
            }
            this.setState({});
        })
    }

    getPoint() {
        this.Actions.getFaceList(parseInt(this.state.labeled), this.state.page, this.state.page_size, (data) => {
            let Data = data.data;
            if (Data && Data.list.length) {
                Data.list.forEach((item, i) => {
                    item.key = i;
                    item.checked = false;
                });
                this.state.dataSource = Data.list;
                this.state.total = Data.total;
            } else {
                this.state.dataSource = [];
                this.state.total = 0;
            }
            this.setState({});

        })
    }

    //获取人脸初始化状态
    initFaceMeta() {
        this.Actions.initFaceMeta((data) => {
            if (data && data.data) {
                if (data.data.initialized) {
                    this.initProgress()
                }
                this.setState({
                    initialized: data.data.initialized
                });
            }
        })
    }

    //开始初始化
    init() {
        this.Actions.faceInitialized((data) => {
            this.initProgress()
        })
    }

    //获取进度条数据
    initProgress() {
        let that = this;
        this.Actions.initProgress((data) => {
            if (data && data.data) {
                let num = data.data;
                if (num < 100) {
                    setTimeout(function () {
                        num++;
                        that.initProgress();
                    }, 15000)  //15秒调取一次
                }
                this.setState({
                    initialized: num === 100 ? false : true,//进度条100的时候，按钮可以再次点击
                    data: num
                });
            }
        })
    }


    render() {
        let height = window.innerHeight - 70;
        let btnStatus = this.props.config.getValueByKey("face_recognition.all_pictures.scan.enable", '0');
        //console.log(typeof btnStatus);
        if (btnStatus === '0') {
            btnStatus=false
        } else {
            btnStatus=true
        }
        return (
            <div className={'FaceRecognition'}
                 style={{position: 'relative', height: height, padding: 20}}>
                <div style={{background: 'white', height: height - 40}}>
                    <Scrollbars>
                        <div>
                            <div style={{paddingLeft: 10}}>
                                <div style={{float: 'left'}}>
                                    <Tabs defaultActiveKey={this.state.labeled} activeKey={this.state.labeled}
                                          onChange={(key) => {
                                              this.state.labeled = key;
                                              this.state.page = 1;
                                              this.state.page_size = 10;
                                              this.refresh();
                                          }} tabBarGutter={0}>
                                        <TabPane tab={"未识别的人物信息"} key={'0'}>
                                        </TabPane>
                                        <TabPane tab={"已识别的人物信息"} key={'1'}>
                                        </TabPane>
                                    </Tabs>
                                </div>
                                {btnStatus ? <div>
                                    <div style={{float: 'left', marginTop: 7, marginLeft: 10}}>
                                        <Button type="primary" disabled={this.state.initialized} onClick={() => {
                                            this.state.initialized = true;
                                            this.init()
                                        }}>全库扫描</Button>
                                    </div>
                                    <div style={{float: 'left', marginTop: 10, marginLeft: 10, width: 400}}>
                                        <Progress percent={this.state.data}
                                                  status={this.state.data < 100 ? "active" : "normal"}/>
                                    </div>
                                </div> : null}


                                <div style={{clear: 'both'}}/>
                                <SpacerBlock height={2}/>
                                <div style={{width: '100%'}}>
                                    {this.state.dataSource.length > 0 ? null : <Empty/>}
                                    {this.state.dataSource.map((item, i) => {
                                        return (
                                            <div key={i} onDoubleClick={() => {
                                                if (this.state.labeled === '0') {
                                                    console.log(this.state.labeled === '0');
                                                    this.state.dataSource[i].checked = true;
                                                    message.info('人物名称设置后不可修改，请谨慎操作！')
                                                }
                                                this.setState({});
                                            }} style={{float: 'left', paddingTop: 10, paddingLeft: 10}}>
                                                <Card
                                                    hoverable
                                                    style={{/*width: 240,*/ textAlign: 'center',}}
                                                    bodyStyle={{padding: 10, textAlign: 'center'}}
                                                >
                                                    <div style={{
                                                        width: 220,
                                                        padding: 10,
                                                        /* marginTop: 10,*/
                                                        float: 'left',
                                                        /*   marginLeft: 10,*/
                                                        textAlign: 'center',
                                                    }}>
                                                        <div>
                                                            <img onDoubleClick={() => {
                                                                /* this.state.dataSource[i].checked = true;*/

                                                            }} style={{
                                                                width: 150,
                                                                height: 150,
                                                                objectFit: 'cover',
                                                                borderRadius: '50%', border: '1px solid #ebebeb'
                                                            }} src={item.face_image_url} alt=""/>
                                                        </div>
                                                        {
                                                            item.checked ? <Input style={{marginTop: 10}}
                                                                                  value={this.state.dataSource[i].label[0]}
                                                                                  onChange={(e) => {
                                                                                      this.state.dataSource[i].label = [e.target.value];
                                                                                      this.setState({});
                                                                                  }
                                                                                  }
                                                                /* onBlur={() => {
                                                                     this.submitName(item);
                                                                 }}*/
                                                                                  onKeyUp={(e) => this.inputKeyUp(e, item)}
                                                                                  placeholder="回车保存人物名称"/> : <div
                                                                style={{
                                                                    textAlign: 'center',
                                                                    fontSize: 14,
                                                                    marginTop: 10,
                                                                    height: 32, lineHeight: '32px'
                                                                }}>{this.state.labeled === '0' ? '双击头像设置人物名称' : item.label[0]}</div>
                                                        }

                                                    </div>
                                                </Card>
                                            </div>

                                        )
                                    })}


                                </div>
                            </div>
                            <div style={{clear: 'both'}}/>
                            {this.state.dataSource.length > 0 ? <div style={{padding: 10}}>
                                <Pagination
                                    showQuickJumper
                                    defaultCurrent={this.state.page}
                                    current={this.state.page}
                                    pageSize={this.state.page_size}
                                    total={this.state.total}
                                    showTotal={total => `共 ${total} 条`}
                                    showSizeChanger
                                    onShowSizeChange={(page, pageSize) => {
                                        this.onChange(page, pageSize);
                                    }}
                                    onChange={(page, pageSize) => this.onChange(page, pageSize)}/>
                            </div> : null}

                        </div>
                    </Scrollbars>
                </div>

            </div>
        )
    }

    //提交或更新名称
    submitName(item) {
        if (item.label.length > 0 && item.label[0].trim().length > 0) {
            if (item.label[0].trim().length <= 6) {
                let body = {
                    "face_id": item.face_id,
                    "label": item.label,
                };
                this.Actions.addFace(JSON.stringify(body), () => {
                    this.refresh();
                });
            } else {
                message.warn('人物名称不能超过6个字！');
            }
        } else {
            message.warn('请输入人物名称！');
        }

    }

    //刷新页面
    refresh() {
        if (this.state.label === '0') {
            this.getNoPoint();
        } else {
            this.getPoint();
        }
    }

    //键盘事件,enter 键提交数据
    inputKeyUp(e, item) {
        if (e.keyCode === 13) {
            this.submitName(item);
        }
    }

    //页数条数发生改变
    onChange(e, pageSize) {
        this.state.page = e;
        this.state.page_size = pageSize;
        this.refresh();
    }

}


function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(FaceRecognition);